module.exports = __webpack_public_path__ + "img/phone_bg.db421578.jpg";